import {
  SimpleColumn,
  SimpleSortableTable,
} from "../../../../../components/ui/simple-sortable-table";
import { SaldoMuveRegistro, SaldoRegistro } from "../types";
import { formatCurrency, formatDate } from "../utils/format";

interface SaldoTableProps {
  registros: SaldoRegistro[] | SaldoMuveRegistro[];
  /** Registros de Muve trazem data de vencimento; os de Entrego não. */
  showVencimento?: boolean;
  /** Registros de Entrego trazem a parte de gorjeta; os de Muve não. */
  showGorjeta?: boolean;
}

const columns: SimpleColumn<SaldoMuveRegistro>[] = [
  {
    key: "data_romaneio",
    label: "Data",
    render: (registro) => formatDate(registro.data_romaneio),
  },
  {
    key: "valor",
    label: "Valor",
    cellClassName: "font-bold",
    render: (registro) => formatCurrency(registro.valor),
  },
  {
    key: "ops",
    label: "OPS",
  },
];

const vencimentoColumn: SimpleColumn<SaldoMuveRegistro> = {
  key: "data_vencimento",
  label: "Vencimento",
  render: (registro) => formatDate(registro.data_vencimento),
};

const gorjetaColumns: SimpleColumn<SaldoMuveRegistro>[] = [
  {
    key: "valor_gorjeta",
    label: "Gorjeta",
    render: (registro) => formatCurrency(registro.valor_gorjeta),
  },
  {
    key: "valor_sem_gorjeta",
    label: "Sem Gorjeta",
    render: (registro) => formatCurrency(registro.valor_sem_gorjeta),
  },
];

export function SaldoTable({
  registros,
  showVencimento,
  showGorjeta,
}: SaldoTableProps) {
  const tableColumns = [
    ...columns,
    ...(showGorjeta ? gorjetaColumns : []),
    ...(showVencimento ? [vencimentoColumn] : []),
  ];

  return (
    <div className="border rounded-lg overflow-hidden">
      <SimpleSortableTable
        columns={tableColumns}
        rows={registros as SaldoMuveRegistro[]}
        rowKey={(registro, index) => `${registro.data_romaneio}-${index}`}
      />
    </div>
  );
}
